import React from 'react';
import { solutionsArticleUrl } from '../../config/solutionsArticles';
import withRouter from 'with-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import withStyles from '../../withStylesAdapter';
import classNames from 'classnames';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import FormGroup from '@mui/material/FormGroup';
import Toolbar from '@mui/material/Toolbar';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Input from '@mui/material/Input';
import OutlinedInput from '@mui/material/OutlinedInput';
import FilledInput from '@mui/material/FilledInput';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import { UpgradePlanHintArea } from '../../components/PricingPlans';
import { glintOnHover } from '../../theme/glint';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
// Hidden removed (deprecated in MUI v5) - using sx display prop instead
import LoadingIndicator from '../../components/LoadingIndicator';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import RemoveOutlined from '@mui/icons-material/RemoveOutlined';
import Collapse from '@mui/material/Collapse';
import InputInformation from '../../components/InputInformation';
import { getLanguages, createLanguage, saveLanguage, deleteLanguage, restoreLanguage, publishLanguage, unpublishLanguage, openLanguageEditor, closeLanguageEditor } from '../../modules/languages';
import { updateSwitcherLanguages, getSwitcherConfig } from '../../modules/switcherConfigurator';
import EmptyView from '../../components/EmptyView';
import { Trans, withTranslation, useTranslation } from 'react-i18next';

import CollapsableSection from '../../components/CollapsableSection';
import Tooltip from '@mui/material/Tooltip';
import API from '../../api/api';
import LanguagePreviewLink from '../../components/LanguagePreviewLink';

class LanguagesSection extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      domainSwitcherInfoDialog: false,
      deleteLanguageDialog: false,
      deleteLanguageId: -1,
      data: {},
      tmpData: {},
    }

    this.handleCreateLanguage = this.handleCreateLanguage.bind(this);
    this.handleEditLanguage = this.handleEditLanguage.bind(this);
    this.handleCloseLanguageDialog = this.handleCloseLanguageDialog.bind(this);
    this.closeDeleteLanguageDialog = this.closeDeleteLanguageDialog.bind(this);
    this.showDeleteLanguageDialog = this.showDeleteLanguageDialog.bind(this);
    this.deleteLanguage = this.deleteLanguage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSaveLanguage = this.handleSaveLanguage.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.openCreateFromLocation();
  }

  componentDidUpdate(prevProps) {
    if(this.props.location?.key !== prevProps.location?.key) this.openCreateFromLocation();
  }

  // the navigation's "add a language" hint lands here with the dialog asked for in the route
  // state; it is cleared right away so a reload or a way back does not open it again
  openCreateFromLocation = () => {
    if(!this.props.location?.state?.createLanguage) return;
    this.props.history.replace({ ...this.props.location, state: {} });
    this.handleCreateLanguage();
  }

  componentWillReceiveProps(newProps) {
    if(!newProps.editTheme) {
      this.setState({open: true});
    }
  }

  handleCreateLanguage() {

    this.setState({ 
      //languageEditorOpen: true,
      //open: false,
      createLanguage: true,
      editLanguage: false,
      codeError: false,
      nameError: false,
      tmpData: {
        id: false,
        name: '',
        base: false,
        code: '',
        code_id: -1,
        domain: '',
        published: false,
        rtl: false,
        removed_on_shopify: false
      },
      data: {
        id: false,
        name: '',
        base: false,
        code: '',
        code_id: -1,
        domain: '',
        published: false,
        rtl: false,
        removed_on_shopify: false
      }
    });

    this.props.openLanguageEditor();
  }

  handleToggleOpen = () => {
    this.setState({ open: !this.state.open });
  }

  closeDomainSwitcherInfoDialog = () => {
    this.setState({
      domainSwitcherInfoDialog: false
    });
  }

  handleEditLanguage(data) {
    this.setState({ 
      //languageEditorOpen: true,
      createLanguage: false,
      editLanguage: true,
      data: data,
      tmpData: data, 
    });

    this.props.openLanguageEditor();
  }

  handleCloseLanguageDialog() {
    this.setState({ 
      //languageEditorOpen: false,
      createLanguage: false,
      editLanguage: false,
      nameError: false,
      codeError: false
    });

    this.props.closeLanguageEditor();
  }

  closeDeleteLanguageDialog() {
    this.setState({
      deleteLanguageId: -1,
      deleteLanguageDialog: false
    })
  }

  showDeleteLanguageDialog(id) {
    this.setState({
      deleteLanguageId: id,
      deleteLanguageDialog: true,
      createLanguage: false,
      editLanguage: false
    })

    this.props.closeLanguageEditor();
  }

  deleteLanguage() {
    const languageToDelete = this.props.languages.languages.find(x => x.id === this.state.deleteLanguageId)
    if(!languageToDelete) {
      this.closeDeleteLanguageDialog()
      return
    }

    this.closeDeleteLanguageDialog()
    this.props.deleteLanguage(languageToDelete.id)

    let newLanguages = this.props.languages.languages.slice();
    newLanguages.splice(this.props.languages.languages.findIndex(x => x.id === languageToDelete.id), 1);
    this.props.updateSwitcherLanguages(newLanguages, this.props.editTheme, this.props.themes.themes);
  }

  restoreLanguage(id)  {
    this.props.restoreLanguage(id)
  }

  handleChange = name => event => {
    let inputType = event.target.type;
    let newData = Object.assign({}, this.state.tmpData);
    let codeError = this.state.codeError;
    let nameError = this.state.nameError;
    if(name === 'code') {
      const languageCode = this.props.languages.available_language_codes.find(x => x.id === event.target.value)
      if(languageCode) {
        newData.rtl = ['ar','am','ff','he','ku','fa','ur'].includes(languageCode.code);
        codeError = false
        newData['code_id'] = languageCode.id
        newData['code'] = languageCode.code
        newData.name = languageCode.name
      }
    } else {
      newData[name] = event.target.value;
      nameError = newData.name.trim() == ''
    }
    this.setState({ ...this.state, tmpData: newData, codeError: codeError, nameError: nameError });
  };

  handleSaveLanguage() {
    const codeError = this.state.tmpData.code_id == -1;
    const nameError = this.state.tmpData.name.trim() == '';

    if(codeError || nameError) {
      this.setState({codeError: codeError, nameError: nameError})

      return;
    }

    this.setState({codeError: false})

    let newData = Object.assign({}, this.state.tmpData);
    this.setState({ data: newData })
    this.props.closeLanguageEditor();
    if(this.state.createLanguage) {
      this.props.createLanguage(newData); 
    } else {
      this.props.saveLanguage(this.state.data.id, newData);
    }
    // a copy: pushing into the store's array left a language without an id behind when the create failed
    let newLanguages = this.props.languages.languages.slice();
    if(!this.props.languages.languages.find(x => x.code === newData.code)) {
      newLanguages.push({
        code: newData.code,
        name: newData.name,
      });
    }

    
    this.props.updateSwitcherLanguages(newLanguages, this.props.editTheme, this.props.themes.themes);
  }

  handlePublishLanguage(data) {
    let newLanguages = this.props.languages.languages.slice();
    if(data.published === true) {
      this.props.unpublishLanguage(data.id);
      newLanguages.find(x => x.id === data.id).published = false;
    } else {
      this.props.publishLanguage(data.id);
      newLanguages.find(x => x.id === data.id).published = true;
    }
    this.props.updateSwitcherLanguages(newLanguages, this.props.editTheme, this.props.themes.themes);
  }

  handleSubmit = (e) => {
    // without it the browser sends the form itself too, a GET reload of the page (?name=...)
    if(e) e.preventDefault();
    this.handleSaveLanguage();
  }



  renderRow = (row) => {
    const { t, classes, theme } = this.props;

    let usedPreviewLink = <Tooltip title="Cannot be viewed before assigned to at least one domain or market" arrow><span className={classes.externalLinkDisabled}>View <OpenInNewIcon style={{fontSize:'18px',color:'inherit'}}/></span></Tooltip>;
    if(row.published == false || (row.assigned_to_domains && row.assigned_to_domains.length > 0)) {
      let usedDomain = (row.assigned_to_domains && row.assigned_to_domains.length > 0) ? row.assigned_to_domains[0] : {'host':this.props.shop.shop.url, 'is_default': row.base};
      let validLink = 'https://' + usedDomain.host;
      if(usedDomain.is_default == false) {
        validLink += '/' + row.code;
      }

      usedPreviewLink = <Tooltip title="You must be logged in shopify to preview un-published languages" arrow><a className={classes.externalLink} href={validLink} target="_blank">{t('languagesSection.view')} <OpenInNewIcon style={{fontSize:'18px',color:'inherit'}}/></a></Tooltip>
    }

    return (
      <TableRow key={row.id}>
        <TableCell width={20} style={{paddingLeft: 24, paddingTop: 6, paddingBottom: 6}}>
          <FormControlLabel control={
            <Switch 
              value={row.published} 
              checked={row.published} 
              onChange={() => this.handlePublishLanguage(row)} 
              disabled={row.base}
            />
          } label="" />
        </TableCell>
        <TableCell padding="none">
          <i className={'ly-flag-icon'} style={{backgroundImage: `url('/flag-icons/${row.code}.svg')`}} />
          {row.name} {(row.base) && '(primary)'}
        </TableCell>
        <TableCell padding="none">
          {this.props.languages.publish_language_requesting == false && row.published == true && row.assigned_to_domains && row.assigned_to_domains.length <= 0 ? (<span className={classes.noDomainWarning}>Not assigned to a domain or market</span>) : (null)}
        </TableCell>
        <TableCell align="left" padding="none" sx={{ display: { xs: 'none', md: 'table-cell' } }}>ly{row.id}</TableCell>
        <TableCell align="left" padding="none" sx={{ display: { xs: 'none', md: 'table-cell' } }}>{row.code}</TableCell>
        <TableCell align="right" padding="none" style={{paddingRight: 24}}>
          {/*
          TODO: Commented out until we found a solution to create correct urls for markets-subfolders configuration

          {usedPreviewLink}
          */}
          {/*<LanguagePreviewLink />*/}
          <Link
            style={{marginLeft:'20px', 'cursor':'pointer'}}
            onClick={() => {this.handleEditLanguage(row)}}
            underline="hover">{t('languagesSection.edit')}</Link>
        </TableCell>
      </TableRow>
    );
  }

  render() {
    const { t, classes, theme } = this.props;
    const { open } = this.state;
    let numLanguages = this.props.languages.languages.length-1;
    if(this.props.shop.shop.charge.name === 'free' && numLanguages > 5) {
      numLanguages = 5;
    }
    // the free plan's 5 are translation languages, the primary language comes on top
    const translationLanguages = this.props.languages.languages
      .filter(x => !x.base && !x.removed_on_shopify)
      .sort((a, b) => a.id - b.id);
    const visibleLanguages = this.props.shop.shop.charge.name === 'free' ? translationLanguages.slice(0, 5) : translationLanguages;
    const freeLimitReached = this.props.shopPlan === 'free' && this.props.languages.languages.length > 5;

    // Check and validate the domain settings and display a notification if action is required
    let showDomainEnableLanguageInfoMessage = '';
    let showDomainEnableLanguageInfoAction = null;
    let showDomainEnableLanguageMissingCount = 0;

    if(this.props.languages.publish_language_requesting == false) {
      this.props.languages.languages.forEach(language => {
        // a language deleted on Shopify's side keeps its published flag here but has nothing left to assign
        if(language.published && !language.removed_on_shopify && (language.assigned_to_domains && language.assigned_to_domains.length <= 0)) {
          showDomainEnableLanguageMissingCount++;
        }
      })
    }

    if(showDomainEnableLanguageMissingCount > 0) {
      // plain inline text like every other section notice; the bar sets colour and layout
      showDomainEnableLanguageInfoMessage = (
        <span>
        {showDomainEnableLanguageMissingCount > 1 ?
          <Trans i18nKey="languagesSection.alertAssignDomains">
            <a href={'https://' + this.props.shop.shop.url + '/admin/settings/languages'} target="_blank" style={{color: 'inherit'}}></a>
            <a href={'https://' + this.props.shop.shop.url + '/admin/settings/domains/'} target="_blank" style={{color: 'inherit'}}></a>
            {{showDomainEnableLanguageMissingCount}}
          </Trans>
          :
          <Trans i18nKey="languagesSection.alertAssignDomain">
            <a href={'https://' + this.props.shop.shop.url + '/admin/settings/languages'} target="_blank" style={{color: 'inherit'}}></a>
            <a href={'https://' + this.props.shop.shop.url + '/admin/settings/domains/'} target="_blank" style={{color: 'inherit'}}></a>
            {{showDomainEnableLanguageMissingCount}}
          </Trans>
        }
        </span>
      )
      showDomainEnableLanguageInfoAction = (
        <Tooltip title={t('navigation.secondary.documentation')}>
          <a href={solutionsArticleUrl('assignLanguagesToDomains')} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', display: 'inline-flex' }}>
            <HelpOutlineIcon style={{ fontSize: 18 }} />
          </a>
        </Tooltip>
      )
    }

    return (
      <div>
        <div variant="body1" className={classNames('languages-section', classes.contentContainer)} data-tour="languages-section">
          <CollapsableSection
            deeplink="languages"
            // a shop without translation languages keeps the section open, adding one is the first step
            initialOpen={open || (this.props.languages.languages.length > 0 && translationLanguages.length === 0)}
            className={classes.collapsableSection}
            title={<Trans i18nKey={this.props.shopPlan === 'free' ? 'languagesSection.titleFreePlan' : 'languagesSection.title'}>
              {{numLanguages}}
            </Trans>}
            ctaBtnHide={false}
            ctaBtnText={t('languagesSection.addNewLanguage')}
            ctaBtnProps={freeLimitReached ? {
              component: RouterLink,
              to: '/profile/plans',
              onClick: undefined,
              sx: { color: '#3a20cd', backgroundColor: '#ffaf23', '&:hover': { backgroundColor: '#f5a30f' }, ...glintOnHover },
            } : {
              disabled: this.props.shopPlan !== 'free' && this.props.languages.languages.length > 20,
            }}
            ctaBtnWrap={freeLimitReached ? btn =>
              <UpgradePlanHintArea placement="bottom" neededPlan="basic" features={[t('plans.navigationHints.languages.feature1')]}>
                <span style={{ display: 'inline-block' }}>{btn}</span>
              </UpgradePlanHintArea>
            : undefined}
            noticeShow={showDomainEnableLanguageMissingCount > 0}
            noticeType={'error'}
            noticeText={showDomainEnableLanguageInfoMessage}
            noticeAction={showDomainEnableLanguageInfoAction}
            ctaBtnAction={this.handleCreateLanguage}
            openBtnText={t('languagesSection.configure')}
            cancelBtnText={t('languagesSection.cancel')}
            pending={false}
            content={this.props.languages.languages.length > 1 ? 
              <Table className={classes.table}>
                <TableHead>
                  <TableRow style={{height: 40}}>
                    <TableCell padding="none" variant="head" style={{paddingLeft: 24}}>{t('languagesSection.active')}</TableCell>
                    <TableCell padding="none" variant="head">{t('languagesSection.language')}</TableCell>
                    <TableCell padding="none" variant="head"></TableCell>
                    <TableCell align="left" padding="none" sx={{ display: { xs: 'none', md: 'table-cell' } }}>{t('languagesSection.id')}</TableCell>
                    <TableCell align="left" padding="none" sx={{ display: { xs: 'none', md: 'table-cell' } }}>{t('languagesSection.code')}</TableCell>
                    <TableCell align="right" padding="none" variant="head" style={{paddingRight: 24}}>{t('languagesSection.actions')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.props.languages.languages.filter(x => x.base).map(row => {
                    return this.renderRow(row);
                  })}
                  {visibleLanguages.map(row => this.renderRow(row))}
                  {this.props.languages.languages.filter(x => x.removed_on_shopify).map(row => {
                    return (
                      <TableRow key={row.id} selected={(!row.published)} className={classNames('languages-section', classes.removedLanguageRow)}>
                        <TableCell width={20} style={{paddingLeft: 24, paddingTop: 6, paddingBottom: 6}}>
                          <FormControlLabel control={
                            <Switch 
                              value={row.published} 
                              checked={false} 
                              onChange={() => this.handlePublishLanguage(row)} 
                              disabled={true}
                            />
                          } label="" />
                        </TableCell>
                        <TableCell className={classNames('languages-section', classes.removedLanguageTitle)} padding="none">
                          <i className={'ly-flag-icon'} style={{backgroundImage: `url('/flag-icons/${row.code}.svg')`}} />
                          {row.name} {t('languagesSection.alertRemovedOnShopify')}
                        </TableCell>
                        <TableCell padding="none" variant="head"></TableCell>
                        <TableCell className={classNames('languages-section', classes.removedLanguageTitle)} padding="none" sx={{ display: { xs: 'none', md: 'table-cell' } }}>ly{row.id}</TableCell>
                        <TableCell className={classNames('languages-section', classes.removedLanguageTitle)} padding="none" sx={{ display: { xs: 'none', md: 'table-cell' } }}>{row.code}</TableCell>
                        <TableCell align="right" padding="none" style={{paddingRight: 24}}>
                          <Link onClick={() => {this.showDeleteLanguageDialog(row.id)}} underline="none" sx={{ cursor: 'pointer' }}>{t('languagesSection.delete')}</Link>
                          <Link
                            className={classNames('languages-section', classes.removedLanguageLink)}
                            onClick={() => {this.restoreLanguage(row.id)}}
                            underline="none" sx={{ cursor: 'pointer' }}>{t('languagesSection.restore')}</Link>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            :
              <EmptyView
                title={t('languagesSection.emptyMessage')}
                description=""
                bottom={
                  <Button
                    variant="contained" 
                    color="primary"
                    size="medium"
                    className={classes.emptyViewButton}
                    onClick={this.handleCreateLanguage}
                    >
                    {t('languagesSection.addNewLanguage')}
                  </Button>
                }
              />
            }
          />

        </div>
        <Dialog
          onClose={this.closeDeleteLanguageDialog}
          aria-labelledby="customized-dialog-title"
          open={this.state.deleteLanguageDialog}
          fullWidth
          maxWidth="sm"
          BackdropProps={{
            style: {
              backgroundColor: 'var(--ly-backdrop)'
            }
          }}
        >
          <DialogTitle id="customized-dialog-title" onClose={this.closeDeleteLanguageDialog}>
            <Typography variant="h5" component="span">{t('languagesSection.deleteLanguage')}</Typography>
          </DialogTitle>
          <DialogContent>
            <p>{t('languagesSection.alertDeleteLanguage')}</p>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={this.closeDeleteLanguageDialog} size="medium">
              {t('languagesSection.cancel')}
            </Button>
            <Button variant="outlined" onClick={this.deleteLanguage} size="medium">
              {t('languagesSection.delete')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          onClose={this.handleCloseLanguageDialog}
          aria-labelledby="customized-dialog-title"
          open={this.props.languages.language_editor_is_open}
          fullWidth
          maxWidth="sm"
          BackdropProps={{
            style: {
              backgroundColor: 'var(--ly-backdrop)'
            }
           }
          }
        >
          <form
            onSubmit={this.handleSubmit}
          >
            <DialogTitle id="customized-dialog-title" onClose={this.handleCloseLanguageDialog}>
              {this.state.createLanguage ? t('languagesSection.createNewLanguage') : t('languagesSection.editLanguage')}
            </DialogTitle>
            <DialogContent>

              {
                this.state.createLanguage ? 
                <FormControl className={classes.formControl} fullWidth>
                  <InputLabel shrink={true} error={this.state.codeError}>{t('languagesSection.languageFieldLabel')}</InputLabel>
                  <Select
                    value={this.state.tmpData.code_id}
                    disabled={!this.state.createLanguage}
                    onChange={this.handleChange('code')}>
                  <MenuItem value="-1" disabled><span style={{color: 'inherit'}}>{t('languagesSection.languageFieldPlaceholder')}</span></MenuItem>
                    {
                      this.props.languages.available_language_codes.map((item) => {
                        return <MenuItem key={item.id} value={item.id}>{item.name} ({item.code})</MenuItem>
                      })
                    }
                  </Select>
                  {this.state.codeError ? (<FormHelperText error={true}>{t('languagesSection.requiredField')}</FormHelperText>) : (<FormHelperText>{t('languagesSection.languageFieldInfo')}</FormHelperText>)}
                </FormControl>
              : null
              }

              <FormControl fullWidth>
                <TextField
                  id="outlined-full-width"
                  label={t('languagesSection.nameFieldLabel')}
                  placeholder={t('languagesSection.nameFieldPlaceholder')}
                  name="name"
                  error={this.state.nameError}
                  value={this.state.tmpData.name}
                  helperText={this.state.nameError ? t('languagesSection.requiredField') : t('languagesSection.nameFieldInfo')}
                  fullWidth
                  margin="normal"
                  onChange={this.handleChange('name')}
                  InputLabelProps={{
                    shrink: true,
                  }} />
              </FormControl>

              {(!this.state.createLanguage && !this.state.data.base) &&
                <div style={{margin: '12px 0'}}>
                  <Link
                    onClick={() => this.showDeleteLanguageDialog(this.state.data.id)}
                    color="error"
                    underline="none"
                    sx={{ cursor: 'pointer' }}>
                    {t('languagesSection.deleteLanguage')}
                  </Link>  
                </div>
              }

            </DialogContent>
            <DialogActions>
              <Button variant="outlined" onClick={this.handleCloseLanguageDialog} size="medium">
                {t('languagesSection.cancel')}
              </Button>
              <Button variant="contained" 
                //onClick={this.handleSaveLanguage} 
                type="submit" color="primary" size="medium">
                {t('languagesSection.saveChanges')}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
        <LoadingIndicator
          pending={this.props.languages.publish_language_requesting || this.props.languages.unpublish_language_requesting || this.props.languages.delete_language_requesting || this.props.languages.restore_language_requesting || this.props.languages.create_language_requesting || this.props.languages.save_language_requesting}
          saving={true}
          progress={0}
          error={this.props.languages.action_error ? { ...this.props.languages.action_error, message: this.props.languages.action_error.message || t('languagesSection.saveFailed') } : false}
        />
      </div>
    );
  }
}

// Markenblau der Links; auf dunklem Grund zu dunkel, daher modusabhängig.
// Lokale Vorwegnahme der Linkfarbe, jetzt auf das Palette-Token gezogen.
// Der Dark-Wert war primary.light (4.65:1), palette.link liegt bei 6.87:1.
const linkColor = (theme) => theme.palette.link;

const styles = (theme, state) => ({
  collapseToggler: {
    cursor: 'pointer',
    color: `${theme.palette.text.primary} !important`,
    fontWeight: '400 !important',
  },
  icon: {
    marginRight: theme.spacing(2),
    opacity: .5,
  },
  root: {
    width: '100%',
    marginTop: 20,
    overflowX: 'auto',
  },
  table: {
    //minWidth: 700,
  },
  contentContainer: {
    marginBottom: theme.spacing(3),
  },
  formControl: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  removedLanguageRow: {
    background: `${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.1)'} !important`,
  },
  removedLanguageTitle: {
    color: theme.palette.error.light,
  },
  removedLanguageLink: {
    paddingLeft: '10px'
  },
  externalLink: {
    color: linkColor(theme),
    textDecoration: 'none',
    "&:visited": {
      color: linkColor(theme),
      textDecoration: 'none'
    },
    "&:hover": {
      color: linkColor(theme),
      textDecoration: 'underline'
    },
    "&:active": {
      color: linkColor(theme),
      textDecoration: 'none'
    },
  },
  externalLinkDisabled: {
    color: theme.palette.text.disabled,
  },
  noDomainWarning: {
    background: theme.palette.error.dark,
    padding: "5px 10px 5px 10px",
    borderRadius: "5px",
    color: "#fff"
  }
});

LanguagesSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({languages, themes, shop, switcherConfigurator}) => ({
  languages: languages,
  themes: themes,
  editTheme: themes.edit_theme,
  shop: shop,
  crossDomainLinksEnabled: shop.shop.cross_domain_links_enabled,
  switcherConfig: switcherConfigurator.switcherConfig,
  shopPlan: shop.shop.charge.name
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getLanguages,
      createLanguage,
      saveLanguage,
      deleteLanguage,
      restoreLanguage,
      publishLanguage,
      unpublishLanguage,
      openLanguageEditor,
      closeLanguageEditor,
      updateSwitcherLanguages,
      getSwitcherConfig,
    },
    dispatch
  )
  
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(LanguagesSection))))
